import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, Typography } from '@mui/material';
import { reportMixPanel } from '@55degrees/consent-tracker';
import useAppTheme from '../../../hooks/useAppTheme';
import personAtDeskDark from '../../../assets/images/person-at-desk-with-charts-dark.png';
import personAtDeskLight from '../../../assets/images/person-at-desk-with-charts-light.png';
import { LandingPageTitle, RegisteredMark } from '../style';
import {
  HelpSectionDescription,
  HelpSectionWrapper,
  HelpSectionLinkList,
  HelpSectionImage,
} from './style';

export default function HelpSection() {
  const { isMobile, isLaptop, isWideScreen, isDarkTheme } = useAppTheme();
  const introductionLink = 'https://community.55degrees.se/spaces/7840791/content';
  const documentationLink = 'https://support.55degrees.se/space/AA4A';

  const handleHelpLinkClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    link: string,
    label: string
  ) => {
    reportMixPanel('Landing Help Link', { Link: label });
  };

  const onIntroductionLinkClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
    handleHelpLinkClick(event, introductionLink, 'Intro Course');

  const onDocumentationLinkClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
    handleHelpLinkClick(event, documentationLink, 'Documentation');

  return (
    <HelpSectionWrapper ismobile={isMobile} islaptop={isLaptop} iswidescreen={isWideScreen}>
      <HelpSectionDescription>
        <LandingPageTitle variant="h5">
          <FormattedMessage
            id="landing.page.help.section.title"
            defaultMessage="Need help getting started?"
          />
        </LandingPageTitle>
        <Typography variant="body1" color="textPrimary">
          <FormattedMessage
            id="landing.page.help.section.blurb.beginning"
            defaultMessage="We’ve got resources to help you feel confident with ActionableAgile Analytics{reg}.
            You’ll find everything you need in the "
            values={{ reg: <RegisteredMark>®</RegisteredMark> }}
          />
          <FormattedMessage
            id="landing.page.help.section.blurb.middle"
            defaultMessage="Help Center"
          />
          <FormattedMessage
            id="landing.page.help.section.blurb.end"
            defaultMessage=" or jump right in with the resources linked here."
          />
        </Typography>
      </HelpSectionDescription>
      <HelpSectionLinkList>
        <li>
          <Link
            href={introductionLink}
            onClick={onIntroductionLinkClick}
            target="_blank"
            color="primary"
          >
            <FormattedMessage
              id="landing.page.help.section.thumbnail.link.introduction"
              defaultMessage="Intro to ActionableAgile{reg} Analytics"
              values={{ reg: <RegisteredMark>®</RegisteredMark> }}
            />
          </Link>
        </li>
        <li>
          <Link
            href={documentationLink}
            onClick={onDocumentationLinkClick}
            target="_blank"
            color="primary"
          >
            <FormattedMessage
              id="landing.page.help.section.thumbnail.link.documentation"
              defaultMessage="Product Documentation"
            />
          </Link>
        </li>
      </HelpSectionLinkList>
      <HelpSectionImage
        src={isDarkTheme ? personAtDeskDark : personAtDeskLight}
        alt="Person at a desk with charts"
        loading="lazy"
        islaptop={isLaptop}
      />
    </HelpSectionWrapper>
  );
}
